export function onTransactionTableRowClick(props, rowItem) {
    const {
        history,
        transactionTableListMenuClickKey,
        transactionTableOpenNewTab,
        transactionTableAfterRowClick,
    } = props;

    // if user clicks on an option in the table list menu
    if (transactionTableListMenuClickKey) {
        const item = rowItem.items.find(x => x.key === transactionTableListMenuClickKey);
        if (item?.url)
        // ctrl+click table list menu items (with url) will open in a new tab
            history.push(item.url);

        else if (item?.action)
            item.action();
    }
    // if the user clicks on anywhere on the table row, AND the first menu item has a url
    else if (rowItem.items[0].url) {
        if (transactionTableOpenNewTab)
            window.open(rowItem.items[0].url);
        else
            history.push(rowItem.items[0].url);

        transactionTableAfterRowClick();
    }
    // if the user clicks on anywhere on the table row, AND the first menu item
    // has an action, BUT NOT a url.
    else if (rowItem.items[0].action) {
        rowItem.items[0].action();
    }

    transactionTableAfterRowClick();
}
